var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayback(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 155 155",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    className: "style-scope yt-icon",
    style: {
      pointerEvents: "none",
      display: "block",
      width: "100%",
      height: "100%"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    viewBox: "0 0 155 155",
    className: "style-scope yt-icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.4 33.2c-40.7 0-72.2 25.3-71.4 63 .4 14 4.2 23.2 10.4 29.2 0 0 38.6 8 60.5 8 21.6 0 46.5 1.9 59.5-11.3 6-6.3 9.6-15.2 9-27.9-1.6-32.6-19.4-61-68-61",
    fill: "#EEE",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5 127.8c14.7 2.3 29.7.8 36.6-2 6.2-2.5 8-6.5 5.6-12a26.4 26.4 0 0 1-.7-1.7c-.7-1.6-1.3-3.2-1.6-4.9-3-13.8 18.5-23.3 10.8-54.5a45.6 45.6 0 0 0-6-14.4c-8-11.9-20.4-12.3-36.7-10.5C41 29.8 26.2 38 25 60.9c-1 17.3 7.7 28 13.9 37 2 3 3.4 5.8 3.4 8.7 0 2.5-.5 4.5-1.4 6.3-2.4 5.5-4 12.7 10.7 15",
    fill: "#00D4B5",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20 112)",
    className: "style-scope yt-icon"
  }, /*#__PURE__*/React.createElement("mask", {
    fill: "#fff",
    className: "style-scope yt-icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.4 1H94v24H.4z",
    className: "style-scope yt-icon"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.7 1.8c2.4 5.5-.2 9.3-6.7 11.5a104 104 0 0 1-35.3 1.5C20.6 13.8 18.4 6.4 20.8 1 18.1 6.4 8.3 11.7.4 13.5c15.2 14.5 40.5 11.2 61 11.2 8.5 0 19.6-.8 28.5-2 4-.4 1.6-1.6 4.2-2.3-4.5-1-3.4-2.5-7.7-5.3A38 38 0 0 1 73.7 1.8",
    fill: "#4620AE",
    mask: "url(#account_playback__b)",
    className: "style-scope yt-icon"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 19)",
    className: "style-scope yt-icon"
  }, /*#__PURE__*/React.createElement("mask", {
    fill: "#fff",
    className: "style-scope yt-icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h27.5v26.8H0z",
    className: "style-scope yt-icon"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.2 25.6c-6.7 1.9-14.7 2.1-19.1-3.9-8.6-11.4 2.2-24 14-21.2C24.5 2.3 28.5 12.8 27.2 20c-.4 2.2-5 5.6-5 5.6",
    fill: "#4620AE",
    mask: "url(#account_playback__d)",
    className: "style-scope yt-icon"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.7 46.2a55.3 55.3 0 0 0 38 3.4l-2-8.7s12.5 4.9 23.4-2.7c-7.8-11.8-20.8-15.7-37-14C40.4 26.2 22.8 38 21.4 61c-1 17.3 11.1 28 17.3 37l15-14.8s-21.4-16.2-17-36.9",
    fill: "#4620AE",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4 57.6c-5.5 0-12 3.6-9.4 12.8 2.7 9 10.8 18.6 22.9 17.8 16.6-1 21.6-12.8 25.5-19.6 3 7.5 11.5 21 25.3 19.8 13.8-1.3 17-17.5 16.8-22.8-.1-5.4-3-8-7.5-8H43.4zM125.9 38.4c-1.5 0-2 3.7-3.2 4.4-1.2.6-3.7.7-3.8 2.3 0 1.6 3.6 1.7 4.4 2.9.9 1.2 1 4.9 2.6 4.7 1.6-.1 1.6-3.9 3.1-5 1.6-1 4.2-.3 4.2-2.1 0-1.9-3.3-1.8-4.3-3.1-1-1.4-1-4.2-3-4.1",
    fill: "#FF76DA",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4 64.3l6.4-6.7h-5.2a48.4 48.4 0 0 0-8.4 8.4c-1 2.4 4.2 2 4.2 2S46.5 78.3 41.8 83c1.2 1 2.5 2 3.9 2.7 5.5-5.5 17.7-17.9 18.2-19.4.6-2-4.5-2-4.5-2M107.8 65l7-7.4h-5a55.1 55.1 0 0 0-9.3 9.2c-1 2.3 4.3 2 4.3 2s-8 9.2-12.6 14.1c1.2 1 2.4 2 3.7 2.7 5.5-5.9 15.9-17.2 16.3-18.7.6-2-4.4-1.9-4.4-1.9",
    fill: "#FFF",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3 67.2l9.6-9.6h-3.2a66.8 66.8 0 0 0-9.3 10c-1 2.3 4.2 2 4.2 2l-6.9 7c.3.6.8 1.4 1.4 2 4.8-4.9 8.4-8.6 8.7-9.5.6-2-4.5-1.9-4.5-1.9M67.7 78.4c1-1 1-1.8-.6-1.7a14 14 0 0 1-3.9 0l4.3-4c.6-.5 1-1 1.5-1.3 1-1-.8-2-3 0-4.6 4-5.6 5.1-5 6.3.2.3.6 1 3.3 1a129 129 0 0 0-9.3 9.6h1.9l.9-.1c3.4-3.6 9-9.1 9.9-9.8M95 71.5l1-.8c.2-.3.1-1.1-.6-1-1.5.2-3.3.3-4.7.1a213 213 0 0 1 11.7-12.2h-2.8C87.7 69.4 87.9 69.9 88.4 70.8c.2.3.6 1 3.3 1l-5 5 1.3 1.6 7-7M111.9 74.2c-1.3 1.9.4 3 1.7 1.3 2-2.3 6.5-7.6 10.7-12.2l-.8-2.1-7.4 7.9-4.2 5",
    fill: "red",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.6 93c3.2-10.4 2.2-12.8 0-13.5-2.1-.8-4.7.4-5.8 6.1 0-4-3.8-6.3-9.3-7.2-5.4-1-6.5 1.8-4.5 4.5-4.4-1.8-6.7 2.4-4.4 4.7-4.1.8-3.2 4.2-1 6.2 2.4 2 7 1.9 8.2 4.6 1.2 2.8-1 8.6-5 8.8-4.2.1-3.8-2.2-3.8-5.8 0-5.3-6.5-7-7.6 2a59.7 59.7 0 0 0 7.5 31.3 48.6 48.6 0 0 0 30.5-12.6c-6-7.3-7.8-19.3-4.8-29",
    fill: "#00D4B5",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9 99c-4.1 0-8.3-1.8-10-5.6-.6-1.5-.3-3.1 1-3.9 1.5-.8 3-.3 4 1 1.3 1.8 3 2.5 5.2 2.4 2.1 0 3.7-.8 4.8-2.5.9-1.4 2.4-2 3.8-1.3s1.8 2.3 1.3 3.8c-1.3 3.8-5.5 6-9.7 6.2H78",
    fill: "#4620AE",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.4 48.3c.4-1.8 2-2.8 3.7-2.4 1.9.3 3 1.9 2.6 3.6A3.1 3.1 0 0 1 143 52c-1.8-.2-3-1.8-2.6-3.7",
    fill: "red",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.9 60.4c.3-1.6 1.7-2.4 3.1-2.1 1.6.3 2.5 1.6 2.2 3a2.7 2.7 0 0 1-3.2 2.2c-1.5-.2-2.4-1.5-2.1-3.1",
    fill: "#00D4B5",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.7 91.2c-.2 0-.4 0-.5-.2-2-1.8-6.3-2.5-8.6-2.5a.8.8 0 0 1 0-1.5c2.6 0 7.3.8 9.6 2.9a.8.8 0 0 1-.5 1.3M126.4 86.5c-.2 0-.4 0-.6-.2-1.9-1.8-6.2-2.5-8.5-2.5a.8.8 0 0 1 0-1.5c2.6 0 7.3.8 9.6 3a.8.8 0 0 1-.5 1.2",
    fill: "#4620AE",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5 62h-5.4c-1 0-4.3 4.6-3.7 5 .6.5 9.1 0 9.1 0v-5z",
    fill: "#FF76DA",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4 57.6s-4 4.4-5.2 6.2c-1.6 2.2.8 4.2 2.9 2 2.3-2.2 7.2-8.2 7.2-8.2h-4.9z",
    fill: "#FFF",
    className: "style-scope yt-icon"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayback);
export default __webpack_public_path__ + "static/media/playback.2993e904d088dfa7786e5872499c7171.svg";
export { ForwardRef as ReactComponent };